export const allRoutes = {
    analytics: '/analytics',
    expenseReports: '/expense-reports',
    expenseWizard: '/expense-wizard',
    backupApprovers: '/re-assign-expenses',
    requestLogs: '/request-logs',
    automationCCFeedsStatsEnhancements:'/automation-cc-feeds-stats-enhancements',
    mergeLineItems:'/merge-line-items',
    userCCFeeds:'/user-cc-feeds',
    userCCFeedsReconciliation:'/user-reconciliation-cc-feeds',
    bankCCDetail:'/bank-cc-detail/:id',
    bankCCFeeds:`/bank-cc-feeds`,
    searchExpense:`/search-expense`,
    impersonateUser: '/impersonate-user',
    bankCCFeedFiles:`/bank-cc-feed-files`,
    bankCCFeedMissingFiles:`/bank-cc-feed-missing-files`,
    SSToBCSyncFeeds:`/SS-To-BC-Sync-Feeds`,
}